export enum ParametrosPortalEnum {
  DESATIVAR_CADASTRO_MOT_AJUD = 'DESATIVAR_CADASTRO_MOT_AJUD',
  CODIGO_DO_SETOR_AJUDANTES = 'CODIGO_DO_SETOR_AJUDANTES',
  VALIDAR_VALOR_MINIMO_PRACA = 'VALIDAR_VALOR_MINIMO_PRACA',
  VALIDAR_VALOR_MINIMO_ROTA = 'VALIDAR_VALOR_MINIMO_ROTA',
  TRABALHAR_TRANSPORTADORA = 'TRABALHAR_TRANSPORTADORA',
  LAYOUT_IMPRESSAO_ROMANEIO = 'LAYOUT_IMPRESSAO_ROMANEIO',
  OUTRO_ERP = 'OUTRO_ERP',
  PERIODO_FINAL_OBRIGATORIO_ROTEIRIZACAO = 'PERIODO_FINAL_OBRIGATORIO_ROTEIRIZACAO',
  DATA_ENTREGA_DIA_ATUAL = 'DATA_ENTREGA_DIA_ATUAL',
  UTILIZA_ROTA_VINCULADA_PRACA = 'UTILIZA_ROTA_VINCULADA_PRACA',
  PERMITIR_QUEBRA_CARREGAMENTO_POR_FILIAL = 'PERMITIR_QUEBRA_CARREGAMENTO_POR_FILIAL',
  OBRIGAR_PEDIDO_MAIS_BONIFICACAO_CARREGAMENTO = 'OBRIGAR_PEDIDO_MAIS_BONIFICACAO_CARREGAMENTO',
  DESATIVAR_CADASTRO_VEICULO = 'DESATIVAR_CADASTRO_VEICULO',
  CONSIDERAR_VLTOTAL_CONSULTA_PEDIDOS = 'CONSIDERAR_VLTOTAL_CONSULTA_PEDIDOS',
  ALTERAR_ENTREGAS_CARREG_P_REENTREGA = 'ALTERAR_ENTREGAS_CARREG_P_REENTREGA',
  POSICAO_PEDIDO_COMBO = 'POSICAO_PEDIDO_COMBO',
  RECALCULAR_CARGA_ALTERADA_ERP = 'RECALCULAR_CARGA_ALTERADA_ERP',
  EXIBIR_SEQ_PEDIDO = 'EXIBIR_SEQ_PEDIDO',
  PERMITIR_QUEBRA_CARREGAMENTO_POR_LOTE  = 'PERMITIR_QUEBRA_CARREGAMENTO_POR_LOTE',
  IGUALAR_SEQ_MONTAGEM = 'IGUALAR_SEQ_MONTAGEM',
  VISUALIZAR_SOMENTE_OBSENTREGA = 'VISUALIZAR_SOMENTE_OBSENTREGA',
  DEFINIR_RESPONSAVEL_ROMANEIO_APK = 'DEFINIR_RESPONSAVEL_ROMANEIO_APK',
  HORARIO_FIM_OPERACAO = 'HORARIO_FIM_OPERACAO',
  HORARIO_INICIO_OPERACAO = 'HORARIO_INICIO_OPERACAO',
  PERMITIR_ALTERAR_ROM_INICIADO = 'PERMITIR_ALTERAR_ROM_INICIADO',
  VALIDAR_ATRASO_ENTREGA = 'VALIDAR_ATRASO_ENTREGA',
  UTILIZA_END_FRETE_TRANSP_PED = 'UTILIZA_END_FRETE_TRANSP_PED',
  VALOR_MINIMO_ENTREGA_FILTRO = 'VALOR_MINIMO_ENTREGA_FILTRO',
  VISUALIZAR_SEQ_PREVISTA_CARGA_ROTEIRIZADA = 'VISUALIZAR_SEQ_PREVISTA_CARGA_ROTEIRIZADA',
  SOLICITA_AUT_VL_ADICIONAL_TAB_FRETE = 'SOLICITA_AUT_VL_ADICIONAL_TAB_FRETE',
  GERAR_GEO_AUTOMATICO = 'GERAR_GEO_AUTOMATICO',
  EXIBIR_PEDIDOS_VINCULADOS_BNF = 'EXIBIR_PEDIDOS_VINCULADOS_BNF',
  EXIBIR_CABECA_CEP_PIN = 'EXIBIR_CABECA_CEP_PIN',
  TAMANHO_CAMPO_DESTINO_CAR = 'TAMANHO_CAMPO_DESTINO_CAR',
  INTERVALO_HORARIO_ALMOCO_FIM = 'INTERVALO_HORARIO_ALMOCO_FIM',
  INTERVALO_HORARIO_ALMOCO_INICIO = 'INTERVALO_HORARIO_ALMOCO_INICIO',
  PRIORIZAR_TAG_ENTREGA_IMPORTACAO_XML = 'PRIORIZAR_TAG_ENTREGA_IMPORTACAO_XML',
  GERAR_CARGA_REENTREGAS = 'GERAR_CARGA_REENTREGAS',
  CONCATENAR_COMPLEMENTO_ENDERECO = 'CONCATENAR_COMPLEMENTO_ENDERECO',
  EXIBIR_AREAS_RODIZIOS_VEICULOS = 'EXIBIR_AREAS_RODIZIOS_VEICULOS',
  PERMITIR_IMPORTAR_XLSX = 'PERMITIR_IMPORTAR_XLSX',
  VALIDAR_CLIENTE_SEFAZ = 'VALIDAR_CLIENTE_SEFAZ',
  TIPO_PONTO_CHEGADA_MOTORISTA = 'TIPO_PONTO_CHEGADA_MOTORISTA',
  HABILITAR_TRANSF_PEDIDOS_CARREGAMENTO = 'HABILITAR_TRANSF_PEDIDOS_CARREGAMENTO',
  CALCULAR_CLIENTE_MAIS_DISTANTE_ROTA = 'CALCULAR_CLIENTE_MAIS_DISTANTE_ROTA',
  ACESSO_TELA_GERACAO_GEOLOCALIZACAO = 'ACESSO_TELA_GERACAO_GEOLOCALIZACAO',
  PERMITIR_USABILIDADE_PRE_CARGA_ROTEIRZADA = 'PERMITIR_USABILIDADE_PRE_CARGA_ROTEIRZADA',
}

export enum ParametrosOcultoEnum {
  EXIBIR_TOTALIZADOR_QUANTIDADE_UNIDADES = 'EXIBIR_TOTALIZADOR_QUANTIDADE_UNIDADES',
}


export enum TipoParametroEnum {
  GERAL = 'Geral',
  FILIAL = 'Filial',
  USUARIO = 'Usuário'
}
